var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert(".bucks-back-merchant-tooltip[data-v-9]{width:370px;margin-top:5px}.bucks-back-merchant-tooltip h4[data-v-9]{margin:0 0 5px;font-weight:600}.bucks-back-merchant-tooltip h4 .badge[data-v-9]{color:#fff;background-color:#53a318;border-radius:3px;line-height:1.7em;padding:0 5px;margin-right:5px}.bucks-back-merchant-tooltip p[data-v-9]{margin-bottom:0}")
;(function(){module.exports = {
  mixins: [require('../../../shared/frontend/vue/vue-mixins')],
  props: {
    loggedIn: Boolean,
    cashbackRate: Number,
    name: String,
    triggerId: {
      type: String,
      "default": 'bucks-back-merchant-tooltip-trigger'
    }
  },
  mounted: function() {
    var $$el, $trigger, open;
    $$el = $(this.$el);
    $trigger = $("#" + this.triggerId);
    open = function() {
      return GIG.Tooltip.open($$el, $trigger);
    };
    if (!this.loggedIn) {
      if (!require('../../../shared/frontend/helpers/helpers').hasOpenModal()) {
        $(function() {
          return setTimeout(open, 300);
        });
      } else {
        GIG.Modal.onClose(open, null, true);
      }
    }
    return $trigger.on('click', open);
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function(){with(this){return _c('div',{staticClass:"bucks-back-merchant-tooltip tooltip",attrs:{"id":"bucks-back-merchant-tooltip"}},[_c('div',{staticClass:"indicator"}),_v(" "),_c('div',{staticClass:"tooltip-content"},[_c('h4',[_c('span',{staticClass:"badge"},[_v(_s(t('js.modules.shared.new')))]),_v(" "+_s(t('js.modules.rewards.merchant_tooltip.title'))+"\n    ")]),_v(" "),_c('p',[_v("\n      "+_s(t('js.modules.rewards.merchant_tooltip.content', { percent: cashbackRate, merchantName: name }))+"\n    ")]),_v(" "),_c('a',{attrs:{"href":t('js.modules.rewards.common.faq_link_url'),"target":"_blank"}},[_v("\n      "+_s(t('js.modules.rewards.merchant_tooltip.detail_link_text'))+"\n    ")])])])}}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-9"
